import React__default, { Component, Fragment } from 'react';
import FocusTrap from './FocusTrapReact.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
class FocusManager extends Component {
  constructor(props) {
    super(props);
    this.id = `fm_${Math.floor(Math.random() * 9999)}`;
    this.onActivate = this.onActivate.bind(this);
    this.onDeactivate = this.onDeactivate.bind(this);
  }
  onActivate() {
  }
  onDeactivate() {
  }
  render() {
    const _a = this.props, { children, focusTrapOptions, isMobile, jsdomMode } = _a, rest = __objRest(_a, ["children", "focusTrapOptions", "isMobile", "jsdomMode"]);
    const options = __spreadProps(__spreadValues({}, focusTrapOptions), {
      onActivate: this.onActivate,
      onDeactivate: this.onDeactivate,
      clickOutsideDeactivates: true
    });
    if (isMobile) {
      return /* @__PURE__ */ React__default.createElement(Fragment, __spreadValues({}, rest), children);
    } else if (jsdomMode) {
      return /* @__PURE__ */ React__default.createElement("div", __spreadValues({}, rest), children);
    } else {
      return /* @__PURE__ */ React__default.createElement(FocusTrap, __spreadValues({ focusTrapOptions: options }, rest), children);
    }
  }
}
FocusManager.defaultProps = {
  isMobile: false,
  focusTrapOptions: {
    clickOutsideDeactivates: true
  },
  jsdomMode: false
};

export { FocusManager as default };
//# sourceMappingURL=FocusManager.js.map
